// Generated by genversion.
export const version = '1.1.0';
